import type { BetSlipState } from '../types';

const errorDismissed = (state: BetSlipState): BetSlipState => ({
  ...state,
  errorCode: undefined
});

export default errorDismissed;
